import { useRef } from 'react';

const useExpiration = ({ expiration }: { expiration: number }) => {
    const expirationDate = useRef<number | null>(null);

    const updateExpirationDate = () => {
        expirationDate.current = Date.now() + expiration;
    };

    const getIsExpired = () => {
        const now = Date.now();

        const isExpired =
            !expirationDate.current || now >= expirationDate.current;

        return isExpired;
    };

    return { getIsExpired, updateExpirationDate };
};

export default useExpiration;
